
interface Props {
    animationDelay: string;
    color: string
    pxSize: number;
}

const SpinnerCircle: React.FC<Props> = ({ animationDelay, color, pxSize }) => {
    return (
        <span className={`${color} rounded-full animate-shrink-grow`}
              style={{ animationDelay: `${animationDelay}`, 
                       height: `${pxSize}px`,
                       width: `${pxSize}px` }}>
        </span>
    )
}

export default SpinnerCircle;
